import { FC } from 'react';

import { ChangeControlDisplay } from '../ChangeControl/ChangeControl';
import { useDocumentOverviewContext } from '../Context';

export const ChangeControlTab: FC = () => {
  const { changeControl, refetchChangeControl } = useDocumentOverviewContext();

  return (
    <ChangeControlDisplay
      changeControl={changeControl}
      refetchChangeControl={refetchChangeControl!}
    />
  );
};
